export default "__VITE_ASSET__D$LPw163__"